import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getGallery, removeGallery } from 'slice/gallerySlice';
import AdminTable from 'common/AdminTable';
import { useNavigate } from 'react-router-dom';

const getImageUrl = (image) => {
  if (!image) return null;
  if (/^https?:\/\//i.test(image)) return image;

  const backendBase = (process.env.REACT_APP_BACKEND || '').replace(/\/+$/, '');
  if (!backendBase) return image;

  const normalizedPath = String(image).replace(/^\/+/, '');
  const fullPath = normalizedPath.startsWith('uploads/')
    ? normalizedPath
    : `uploads/gallery/${normalizedPath}`;
  return `${backendBase}/${fullPath}`;
};

const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const galleryData = useSelector((state) => state.gallery);

  // ✅ Fetch gallery list
  useEffect(() => {
    dispatch(getGallery());
  }, [dispatch]);

  // ✅ Remove handler (fixes ESLint warning)
  const handleRemove = async (id) => {
    if (!window.confirm('Delete this gallery item?')) return;
    dispatch(removeGallery(id));
  };

  const tableHeaders = [
    {
      Header: 'ID',
      accessor: 'id'
    },
    {
      Header: 'Name',
      accessor: 'name'
    },
    {
      Header: 'Image',
      accessor: 'image',
      Cell: ({ row }) =>
        row.original.image ? (
          <img src={getImageUrl(row.original.image)} alt={row.original.name} width={100} />
        ) : (
          'No Image'
        )
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button className="btn btn-danger mx-1" onClick={() => handleRemove(row.original.id)}>
            Remove
          </button>

          <button className="btn btn-primary mx-1" onClick={() => navigate(`/gallery/update/${row.original.id}`)}>
            Edit
          </button>
        </>
      )
    }
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Gallery List</h4>
      </div>

      {galleryData?.data?.length > 0 ? (
        <AdminTable tableHeaders={tableHeaders} tableData={galleryData.data} />
      ) : (
        <p className="text-white mx-4 mt-3">No gallery items found.</p>
      )}
    </div>
  );
};

export default List;
